import { CHANGE_ROUTE } from '@app/actions/_types';

const initialMatrixState = {
  target: {
    name: '',
    ep: '',
  },
  design: {
    product: '',
    design: '',
  },
  customize: {
    path: '',
    storage: '',
    snapshot: '',
    project: '',
  },
  ctx: {
    designSource: '',
    cornerRadius: '',
    designName: '',
    consumer: '',
    height: '',
    width: '',
    shape: '',
    mode: '',
    qty: '',
  },
  view: '',
};

export default (state = initialMatrixState, { type, payload } = {}) => {
  if (type === CHANGE_ROUTE) {
    return {
      ...initialMatrixState,
      ...payload.matrix,
      view: payload.view,
    };
  }
  return state;
};
